/*
  ofertas-svhub-reviews.js
  ─────────────────────────────────────────────────────────────────────
  Render lazy de reseñas (SCM + Loox) para la PDP.

  Este archivo es JS puro estático: se sirve desde el CDN de Shopify y
  se cachea con far-future, así NO se reenvía con cada PDP (a diferencia
  del bloque <script> inline anterior que pesaba ~13 KB por producto).

  Los datos (scm + loox) los inyecta el snippet liquid en
  `window.__ofertasSvhubReviewsData[productId]` antes de cargar este JS.

  Convención del contenedor:
    <div id="ofertas-svhub-reviews" data-product-id="123">…</div>
*/
(function () {
  if (window.__ofertasSvhubReviewsInit) return;
  window.__ofertasSvhubReviewsInit = true;

  // Constantes a nivel IIFE (fuera de init) para evitar bug de hoisting
  // donde MONTH_MAP queda undefined cuando sort() llama parseDate().
  var MONTH_MAP = {
    '1':0,'01':0,'jan':0,'ene':0,'january':0,'enero':0,
    '2':1,'02':1,'feb':1,'february':1,'febrero':1,
    '3':2,'03':2,'mar':2,'march':2,'marzo':2,
    '4':3,'04':3,'apr':3,'abr':3,'april':3,'abril':3,
    '5':4,'05':4,'may':4,'mayo':4,
    '6':5,'06':5,'jun':5,'june':5,'junio':5,
    '7':6,'07':6,'jul':6,'july':6,'julio':6,
    '8':7,'08':7,'aug':7,'ago':7,'august':7,'agosto':7,
    '9':8,'09':8,'sep':8,'sept':8,'september':8,'septiembre':8,
    '10':9,'oct':9,'october':9,'octubre':9,
    '11':10,'nov':10,'november':10,'noviembre':10,
    '12':11,'dec':11,'dic':11,'december':11,'diciembre':11
  };
  var ES_MONTHS = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];

  function _parseDateParts(s) {
    if (!s) return null;
    try {
      var datePart = String(s).split(' ')[0].split('T')[0];
      var sep = datePart.indexOf('/') >= 0 ? '/' : (datePart.indexOf('-') >= 0 ? '-' : null);
      if (!sep) return null;
      var p = datePart.split(sep);
      if (p.length !== 3) return null;
      var day, monthStr, year;
      if (p[0].length === 4) {
        year = +p[0]; monthStr = p[1]; day = +p[2];
      } else {
        day = +p[0]; monthStr = p[1]; year = +p[2];
      }
      if (monthStr == null) return null;
      var mIdx = MONTH_MAP[String(monthStr).toLowerCase()];
      if (mIdx == null || isNaN(day) || isNaN(year)) return null;
      return { day: day, month: mIdx, year: year };
    } catch (e) { return null; }
  }
  function parseDate(s) {
    var p = _parseDateParts(s);
    if (!p) return 0;
    return new Date(p.year, p.month, p.day).getTime();
  }
  function formatDate(s) {
    var p = _parseDateParts(s);
    if (!p) return '';
    return p.day + ' ' + ES_MONTHS[p.month] + ' ' + p.year;
  }

  // atob() devuelve bytes Latin-1; necesitamos interpretarlos como UTF-8
  // para que las tildes y eñes se vean bien (Aún, español, etc).
  function b64DecodeUtf8(str) {
    try {
      return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    } catch (e) {
      return atob(str);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function stars(n) {
    var s = '';
    for (var i = 1; i <= 5; i++) {
      var color = i <= n ? '#fbbf24' : '#e5e7eb';
      // El tema tiene `svg { fill: currentColor }` global → forzamos con inline + !important
      s += '<svg width="18" height="18" viewBox="0 0 24 24"' +
           ' style="display:inline-block !important; vertical-align:middle !important;' +
           ' fill:' + color + ' !important; color:' + color + ' !important;' +
           ' width:18px !important; height:18px !important;">' +
           '<path fill="' + color + '" style="fill:' + color + ' !important;"' +
           ' d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    return s;
  }

  function renderReview(r) {
    var photos = '';
    if (r.has_photo && Array.isArray(r.photosArray) && r.photosArray.length) {
      photos = '<div style="display:flex; gap:4px; margin-top:6px; flex-wrap:wrap;">';
      for (var i = 0; i < r.photosArray.length; i++) {
        var p = r.photosArray[i];
        var src = typeof p === 'string' ? p : (p.url || p.src || p.thumbnail || '');
        if (src) {
          photos += '<a href="' + escapeHtml(src) + '" target="_blank" rel="noopener" style="display:block;">' +
                    '<img src="' + escapeHtml(src) + '" alt="Foto" style="width:44px; height:44px; object-fit:cover; border-radius:4px; border:1px solid #e5e7eb;"/></a>';
        }
      }
      photos += '</div>';
    }
    var verified = r.status === 1
      ? '<span style="display:inline-flex; align-items:center; gap:2px; font-size:0.62rem; color:#16a34a; background:#dcfce7; padding:1px 5px; border-radius:3px; margin-left:4px;">✓</span>'
      : '';
    var pinned = r.is_pinned
      ? '<span style="font-size:0.62rem; color:#7c3aed; background:#ede9fe; padding:1px 5px; border-radius:3px; margin-left:4px;">📌</span>'
      : '';
    return '' +
      '<div class="ofertas-svhub-review" ' +
        'style="background:#fff; border:1px solid #e5e7eb; border-radius:8px; ' +
        'padding:18px 20px; box-shadow:0 1px 2px rgba(0,0,0,0.04); ' +
        'transition:box-shadow 0.2s;">' +
        '<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:8px; flex-wrap:wrap; gap:8px;">' +
          '<div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap; min-width:0;">' +
            '<span style="font-weight:700; font-size:1.05rem; color:#111827;">' + escapeHtml(r.author || 'Cliente') + '</span>' +
            verified + pinned +
          '</div>' +
          '<span style="color:#9ca3af; font-size:0.9rem;">' + formatDate(r.date) + '</span>' +
        '</div>' +
        '<div style="margin-bottom:10px;">' + stars(r.rating || 0) + '</div>' +
        '<div style="color:#374151; font-size:1rem; line-height:1.55; white-space:pre-wrap; word-wrap:break-word;">' + escapeHtml(r.review || '') + '</div>' +
        photos +
      '</div>';
  }

  function init(container) {
    if (!container) container = document.getElementById('ofertas-svhub-reviews');
    if (!container) return;
    var listEl = document.getElementById('ofertas-svhub-reviews-list');
    var moreBtn = document.getElementById('ofertas-svhub-reviews-more');

    // Datos inyectados por el snippet liquid antes de cargar este JS.
    // Soporta dos formas:
    //   - window.__ofertasSvhubReviewsData[productId] = { scm, loox }
    //   - window.__ofertasSvhubReviewsData = { scm, loox }  (fallback)
    var data = window.__ofertasSvhubReviewsData || {};
    var pid = container.getAttribute('data-product-id');
    var bucket = (pid && data[pid]) ? data[pid] : data;
    var scmRaw  = bucket && 'scm'  in bucket ? bucket.scm  : null;
    var looxRaw = bucket && 'loox' in bucket ? bucket.loox : null;

    var reviews = [];

    // 1) Intentar SCM (JSON con base64 interno).
    //    scmRaw puede ser:
    //    - objeto (Liquid auto-parseó) → usar directo
    //    - string JSON → JSON.parse
    //    - "[object Object]" → metafield drop mal serializado, descartar
    var scmReviews = [];
    if (scmRaw && scmRaw !== '[object Object]') {
      try {
        var outer = typeof scmRaw === 'string' ? JSON.parse(scmRaw) : scmRaw;
        if (outer && outer.reviewItems) {
          var decoded = b64DecodeUtf8(outer.reviewItems);
          var inner = JSON.parse(decoded);
          if (inner.reviews && Array.isArray(inner.reviews)) {
            scmReviews = inner.reviews.map(function (r) {
              return {
                author: r.author, rating: r.rating || 5, date: r.date,
                review: r.review, has_photo: r.has_photo,
                photosArray: r.photosArray || [],
                status: r.status, is_pinned: r.is_pinned, source: 'scm',
                _sortKey: parseDate(r.date)
              };
            });
          }
        }
      } catch (e) {
        console.warn('[svhub-reviews] scm parse err:', e);
      }
    }

    // 2) Loox HTML (mas simple: solo autor + texto, sin fechas/fotos)
    var looxReviews = [];
    if (looxRaw && looxRaw !== '[object Object]') {
      try {
        var looxStr = typeof looxRaw === 'string' ? looxRaw : '';
        var tmp = document.createElement('div');
        tmp.innerHTML = looxStr;
        var nodes = tmp.querySelectorAll('.review');
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          var nameEl = node.querySelector('.name');
          var textEl = node.querySelector('.review_text');
          var ratingEl = node.querySelector('.rating, [class*="star"]');
          var rating = 5;
          if (ratingEl) {
            var rAttr = ratingEl.getAttribute('data-rating') || ratingEl.getAttribute('data-score');
            if (rAttr) rating = parseInt(rAttr, 10) || 5;
          }
          looxReviews.push({
            author: nameEl ? nameEl.textContent.trim() : 'Cliente',
            rating: rating,
            date: '',
            review: textEl ? textEl.textContent.trim() : '',
            has_photo: false,
            photosArray: [],
            status: 1,
            is_pinned: false,
            source: 'loox',
            _sortKey: 0
          });
        }
      } catch (e) {
        console.warn('[svhub-reviews] loox parse err:', e);
      }
    }

    // 3) Combinar SCM (rica) + Loox (cantidad), dedup por autor+text
    reviews = scmReviews.slice();
    var seen = {};
    scmReviews.forEach(function (r) {
      var k = (r.author || '').toLowerCase() + '|' + (r.review || '').substring(0, 30).toLowerCase();
      seen[k] = true;
    });
    looxReviews.forEach(function (r) {
      var k = (r.author || '').toLowerCase() + '|' + (r.review || '').substring(0, 30).toLowerCase();
      if (!seen[k]) {
        reviews.push(r);
        seen[k] = true;
      }
    });
    console.log('[svhub-reviews] scm=' + scmReviews.length + ' loox=' + looxReviews.length + ' total=' + reviews.length);

    if (!reviews.length) {
      listEl.innerHTML = '<div style="color:#6b7280;">Aún no hay reseñas detalladas para este producto.</div>';
      return;
    }
    // Ordenar: pinned primero, después por fecha (más recientes)
    // _sortKey ya está pre-cacheado en cada review (parseDate corre 1 vez, no O(n log n))
    reviews.sort(function (a, b) {
      if (a.is_pinned && !b.is_pinned) return -1;
      if (!a.is_pinned && b.is_pinned) return 1;
      return b._sortKey - a._sortKey;
    });
    var INITIAL = 5;   // primeras N reseñas mostradas al cargar
    var BATCH = 20;    // cuántas cargar al click "Mostrar más"
    var shown = 0;     // ya renderizadas

    // Renderiza un bloque y actualiza el botón.
    function showBatch(batchSize) {
      var next = reviews.slice(shown, shown + batchSize);
      var html = next.map(renderReview).join('');
      if (shown === 0) {
        listEl.innerHTML = html;
      } else {
        listEl.insertAdjacentHTML('beforeend', html);
      }
      shown += next.length;
      if (shown >= reviews.length) {
        moreBtn.style.display = 'none';
      } else {
        moreBtn.style.display = 'inline-block';
        var rem = reviews.length - shown;
        var nextN = Math.min(BATCH, rem);
        moreBtn.textContent = 'Mostrar ' + nextN + ' más reseñas (' + rem + ' restantes)';
      }
    }
    // Botón = carga BATCH (20) en cada click
    moreBtn.addEventListener('click', function () { showBatch(BATCH); });
    // Render inicial: primeras INITIAL
    showBatch(INITIAL);
  }

  // Lazy: solo parsear cuando el contenedor entra al viewport.
  // Las reseñas viven al final de la PDP — no hay razón para gastar
  // CPU en base64 + JSON.parse + sort hasta que el usuario scrollee.
  function initLazy() {
    var container = document.getElementById('ofertas-svhub-reviews');
    if (!container) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, observer) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            observer.disconnect();
            init(container);
            return;
          }
        }
      }, { rootMargin: '300px' });
      io.observe(container);
    } else {
      init(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazy);
  } else {
    initLazy();
  }
})();
